<template>
    <div
        tabindex="0"
        class="tw-relative border-default tw-cursor-pointer tw-block tw-w-full tw-py-4 tw-pl-2 tw-pr-6 hover:tw-bg-blue-50 tw-flex tw-items-center tw-justify-center lg:tw-justify-start tw-outline-none"
        :class="` ${isActive && 'tw-bg-blue-100'} ${store.isBlocked(store.other_user(chat)) && 'tw-opacity-50'}`"
    >
        <img :src="store.chat_image(chat)" alt="" class="tw-w-10 tw-h-10 tw-rounded-full lg:tw-mr-2">
        <div class="tw-hidden lg:tw-block tw-overflow-hidden">
            <div class="tw-text-left">
                <span>{{store.chat_title(chat)}}</span>
                <!--<span v-if="chat.unread_messages_count !== 0" class="tw-inline-block tw-px-2 tw-rounded-sm tw-bg-red tw-text-light tw-font-bold  tw-relative tw-bottom-2px">{{chat.unread_messages_count}}</span>-->
            </div>
            <div class="tw-text-gray-500 tw-text-sm tw-truncate">{{chat.last_message}}</div>
        </div>
        <div v-if="store.has_new_message(chat)" class="tw-absolute tw-right-0 tw-top-0 tw-mr-4 tw-h-full tw-flex tw-items-center tw-justify-center">
            <div class="tw-rounded-2xl tw-bg-red-600 tw-w-2 tw-h-2"></div>
        </div>
    </div>
</template>
<script>
    import store from './messenger-store'
    export default {
        props: {
            user: {},
            chat: {},
            isActive: {},
        },
        created() {
            this.store = store
            store.states.user = this.user
        },
    }
</script>
